import React from "react";
import { AdsSlotProps } from "./Ads.Slot";
import AdsSlotEngine from "./Ads.Slot.Engine";

const urlMapRegex = {
  "/$": "home",
  "^/economia/concursos-e-empregos.*": "empresasnegocios",
  "^/economia/empresas-e-negocios.*": "empresasnegocios",
  "^/economia/loterias.*": "empresasnegocios",
  "^/economia/sobre-rodas.*": "empresasnegocios",
  "^/economia.*": "economia",
  "^/cidades/judiciario.*": "judiciario",
  "^/cidades.*": "cidades",
  "^/esporte.*": "esporte",
  "^/infomercial.*": "infomercial",
  "^/magazine/bip.*": "bip",
  "^/magazine/cronicas-causos.*": "cronicascausos",
  "^/magazine/cinema.*": "cinema",
  "^/magazine.*": "magazine",
  "^/opiniao/jorge-braga.*": "jorgebraga",
  "^/opiniao/tendencias-e-ideais.*": "opiniao",
  "^/opiniao.*": "opiniao",
  "^/politica/coluna-esplanada*": "colunaeesplanada",
  "^/politica/antena-ligada.*": "antenaligada",
  "^/politica/eleicoes.*": "eleicoes",
  "^/politica.*": "politica",
  "^/mundo.*": "mundo",
  "^/vida-urbana./judiciario*": "judiciario",
  "^/vida-urbana./sustentabilidade.*": "sustentabilidade",
  "^/vida-urbana.*": "vidaurbana",
  "^/videos.*": "videos",
  "^/ultimas.*": "ultimas",
} as const; 

type SectionName = typeof urlMapRegex[keyof typeof urlMapRegex];

type Slot = {
  id: string;
  position: string;
  nthPosition?: Array<Number>; //Slot potion by occurence, like 0, 1, 2, 3... The number represent when to be rendered by ocorrence
  customHtml?: String;
  customEventName?: String
};

type DeviceSlotType = {
  desktopSlot?: Slot;
  mobileSlot?: Slot;
};

type PlacementType = {
  [placement in AdsSlotProps["componentReference"]]?: DeviceSlotType;
};

type BlockType = {
  [blockType in AdsSlotProps["type"]]?: PlacementType;
};

type AdsSettings = {
  [section: string]: {
    [subsection in SectionName | "*"]?: BlockType;
  };
};
 
const settings: AdsSettings ={
   "Capa - manchete sem foto": {
      "home": {
         "block": {
            "top": {
               "desktopSlot": {
                  "id": "Alright",
                  "position": "HTML",
                  "customHtml": "<div id='div-gpt-ad-1737052441084-0'></div>",
                  "customEventName": "div-gpt-ad-1737052441084-0"
               },
               "mobileSlot": {
                  "id": "Alright",
                  "position": "HTML_M",
                  "customHtml": "<div id='div-gpt-ad-1737052835947-0'></div>",
                  "customEventName": "div-gpt-ad-1737052835947-0"
               }
            }
         }
      }
   },
   "Capa - fotão, secundárias e rodapé": {
      "home": {
         "block": {
            "top": {
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM1_M"
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Infomercial - destaques": {
      "home": {
         "block": {
            "top": {
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM1_M"
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas Capa": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      }
   },
   "Elementos - Radio": {
      "home": {
         "side": {
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      }
   },
   "Vídeos - CAPA": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      }
   },
   "Cidades - Capa 1": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "cidades": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Economia - CAPA 1": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "economia": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Economia": {
      "economia": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas de Cidades": {
      "cidades": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Política - CAPA": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "politica": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Política": {
      "politica": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas notícias Eleicoes": {
      "eleicoes": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas notícias": {
      "empresasnegocios": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM1_M"
               }
            }
         }
      },
      "economia": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM1_M"
               }
            }
         }
      },
      "bip": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM1_M"
               }
            }
         }
      },
      "cronicascausos": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM1_M"
               }
            }
         }
      },
      "cinema": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      },
      "antenaligada": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM1_M"
               }
            }
         }
      },
      "colunaeesplanada": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM1_M"
               }
            }
         }
      },
      "judiciario": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      },
      "sustentabilidade": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Esporte - CAPA": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "esporte": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas notícias Cinema": {
      "cinema": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas notícias Esplanada": {
      "colunaeesplanada": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Esporte": {
      "esporte": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas de Infomercial": {
      "infomercial": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Magazine - CAPA 1": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "magazine": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Magazine ultimas": {
      "magazine": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Magazine": {
      "magazine": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Mundo - CAPA": {
      "home": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "LEADBRD3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "mundo": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas de Mundo": {
      "mundo": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Opinião - CAPA": {
      "opiniao": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas Jorge Braga": {
      "jorgebraga": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas notícias Jorge Braga": {
      "jorgebraga": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas Tendências e Ideias": {
      "opiniao": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas notícias Tendencias e ideias": {
      "opiniao": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Lateral - Últimas": {
      "home": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "empresasnegocios": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM2_M"
               }
            }
         }
      },
      "cidades": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "RM3_M"
               }
            }
         }
      },
      "economia": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "RM3_M"
               }
            }
         }
      },
      "esporte": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "RM3_M"
               }
            }
         }
      },
      "infomercial": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "RM2_M"
               }
            }
         }
      },
      "magazine": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM3_M"
               }
            }
         }
      },
      "bip": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM2_M"
               }
            }
         }
      },
      "cronicascausos": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "RM2_M"
               }
            }
         }
      },
      "cinema": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M"
               }
            }
         }
      },
      "mundo": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "RM2_M"
               }
            }
         }
      },
      "opiniao": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM2_M"
               }
            }
         }
      },
      "jorgebraga": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Opiniao",
                  "position": "RM2_M"
               }
            }
         }
      },
      "colunaeesplanada": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM2_M"
               }
            }
         }
      },
      "antenaligada": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM2_M"
               }
            }
         }
      },
      "politica": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "RM3_M"
               }
            }
         }
      },
      "eleicoes": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "RM3_M"
               }
            }
         }
      },
      "vidaurbana": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M"
               }
            }
         }
      },
      "judiciario": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M"
               }
            }
         }
      },
      "sustentabilidade": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M"
               }
            }
         }
      },
      "videos": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "RM3_M"
               }
            }
         }
      },
      // "artigos": {
      //    "side": {
      //       "top": {
      //          "desktopSlot": {
      //             "id": "gjc_JTO",
      //             "position": "MPAG1"
      //          }
      //       },
      //       "bottom": {
      //          "mobileSlot": {
      //             "id": "gjc_JTO",
      //             "position": "RM2_M"
      //          }
      //       }
      //    }
      // }
   },
   "Últimas": {
      "ultimas": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Mais lidas": {
      "home": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM1"
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO.Home",
                  "position": "RM3_M"
               }
            }
         }
      },
      "ultimas": {
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "MPAG1"
               }
            },
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Ultimas",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Vida Urbana - Capa 1": {
      "vidaurbana": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Últimas de Vida Urbana": {
      "vidaurbana": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Opinião": {
      "mundo": {
         "block": {
            "bottom": {
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Vídeos - destaques": {
      "videos": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "Últimas de Vídeos": {
      "videos": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "LEADBRD2"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Videos",
                  "position": "RM2_M"
               }
            }
         }
      }
   },
   "Matéria - Cidades- JTO": {
      "cidades": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Cidades",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - genérica": {
      "*": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Economia- JTO": {
      "economia": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Economia",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria -Esporte- JTO": {
      "esporte": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Esporte",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Magazine - JTO": {
      "magazine": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Magazine",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Mundo - JTO": {
      "mundo": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Opiniao - JTO": {
      "opiniao": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Mundo",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Politica - JTO": {
      "*": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Politica",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Matéria - Infomercial - JTO": {
      "infomercial": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Especial_Publicitario",
                  "position": "BILL_MAXI1_M"
               }
            }
         }
      }
   },
   "Eleições - CAPA": {
      "*": {
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "BILL_MAXI1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "BILL_MAXI1_M"
               }
            }
         },
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "LEADBRD1"
               },
               "mobileSlot": {
                  "id": "gjc_JTO/Eleicoes",
                  "position": "RM1_M"
               }
            }
         }
      }
   },
   "generic": {
      "*": {
         "article": {
            "top": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            }
         },
         "block": {
            "top": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            }
         },
         "mega": {
            "top": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            }
         },
         "side": {
            "top": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            }
         },
         "search": {
            "top": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            },
            "bottom": {
               "desktopSlot": {
                  "id": "JTO_INTERNAS_DSK_MBOX9999",
                  "position": "",
               },
               "mobileSlot": {
                  "id": "JTO_INTERNAS_SMT_RM9999",
                  "position": "",
               }
            }
         }
      }
   },
   "Search Slot": {
      "*": {
         "search": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MBOX1",
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1_M",
               }
            }
         }
      }
   },
   "Search Filter": {
      "*": {
         "block": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "RM1",
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM2_M",
               }
            }
         }
      }
   },
   "Article Slot": {
      "*": {
         "article": {
            "bottom": {
               "desktopSlot": {
                  "id": "gjc_JTO",
                  "position": "MBOX?"
               },
               "mobileSlot": {
                  "id": "gjc_JTO",
                  "position": "RM?_M"
               }
            }
         }
      }
   }
}; 

// Slot sizes to be used a fixed size for the slots
const slotSizeMap = {
  JTO_HOME_SMT_BILL1_MAXI1: [300, 250],
  JTO_HOME_SMT_RM1: [300, 250],
  JTO_HOME_SMT_RM2: [300, 250],
  JTO_HOME_SMT_RM3: [300, 250],
  JTO_INTERNAS_SMT_BILL1_MAXI1: [300, 250],
  JTO_INTERNAS_SMT_RM1: [300, 250],
  JTO_INTERNAS_SMT_RM2: [300, 250],
  JTO_INTERNAS_SMT_RM3: [300, 250],
  JTO_HOME_DSK_BILL1_MAXI1: [970, 250],
  JTO_INTERNAS_DSK_BILL1_MAXI1: [970, 250],
  JTO_HOME_DSK_RM1: [300, 250],
  JTO_HOME_DSK_RM2: [300, 250],
  JTO_HOME_DSK_RM3: [300, 250],
  JTO_HOME_DSK_LEADBRD1: [728, 90],
  JTO_HOME_DSK_LEADBRD2: [728, 90],
  JTO_HOME_DSK_LEADBRD3: [728, 90],
  JTO_HOME_DSK_MPAG1: [300, 600],
  JTO_HOME_DSK_MPAG2: [300, 600],
  JTO_HOME_DSK_MPAG3: [300, 600],
  JTO_INTERNAS_DSK_MPAG1: [300, 600],
  JTO_INTERNAS_DSK_MPAG2: [300, 600],
  JTO_INTERNAS_DSK_MPAG3: [300, 600],
  JTO_INTERNAS_DSK_MBOX1: [600, 300],
  JTO_INTERNAS_DSK_MBOX2: [600, 300],
  JTO_INTERNAS_DSK_MBOX3: [600, 300],

  'gjc_JTO.Home': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
  
  'gjc_JTO': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Cidades': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Ultimas': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Eleicoes': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Politica': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Esporte': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Economia': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Magazine': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Videos': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Opiniao': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Mundo': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },

  'gjc_JTO/Especial_Publicitario': {
    BILL_MAXI1: [970, 250],
    LEADBRD1: [728, 90],
    LEADBRD2: [728, 90],
    LEADBRD3: [728, 90],
    MPAG1: [300, 600],
    MPAG2: [300, 600],
    MPAG3: [300, 600],
    RM1: [300, 250],
    RM2: [300, 250],
    RM3: [300, 250],
    MBOX1: [600, 300],
    MBOX2: [600, 300],
    MBOX3: [600, 300],
    BILL_MAXI1_M: [300, 250],
    RM1_M: [300, 250],
    RM2_M: [300, 250],
    RM3_M: [300, 250],
  },
};

const AdsSlot: React.FC<AdsSlotProps> = ({
  type,
  componentReference = "bottom",
  data,
}) => {
 return (
   <AdsSlotEngine
     settings={settings}
     urlMapRegex={urlMapRegex}
     slotSizeMap={slotSizeMap}
     type={type}
     componentReference={componentReference}
     data={data}
   />
 )
}

export default AdsSlot;
